import { socket } from "./socketClient";
import moment from "moment-timezone";

const handleSocketEvent = (event, callback) => {
  socket.on(event, ({ data }) => {
    const newData = data[0];
    const currentTimezone = localStorage.getItem("timezone");
    if (newData && moment(newData?.createdAt).tz(currentTimezone, true).isAfter(moment.tz(currentTimezone))) {
      return;
    }
    return callback(newData);
  });
};

const handleSocketEvent2 = (event, callback) => {
  socket.on(event, (data) => {
    const newData = data;
    return callback(newData);
  });
};

const handleSocketEvent3 = (event, callback) => {
  socket.on(event, (data) => {
    return callback(data?.data);
  });
};

export { handleSocketEvent, handleSocketEvent2, handleSocketEvent3 };
